import { createEvent } from 'effector';

import { ExportsManagementState } from './ExportsManagementState';

export const exportsManagementEvent =
  createEvent<Partial<ExportsManagementState>>('exportsManagement');
